// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IFieldStateType } from './IFieldStateType';
import {
    IFieldStateTypeFromJSON,
    IFieldStateTypeFromJSONTyped,
    IFieldStateTypeToJSON,
    IFieldStateTypeToJSONTyped,
} from './IFieldStateType';

/**
 * 
 * @export
 * @interface IBinSetupInfoDto
 */
export interface IBinSetupInfoDto {
    /**
     * 
     * @type {string}
     * @memberof IBinSetupInfoDto
     */
    bin_setup: string;
    /**
     * 
     * @type {IFieldStateType}
     * @memberof IBinSetupInfoDto
     */
    bin_setup_state?: IFieldStateType;
}



/**
 * Check if a given object implements the IBinSetupInfoDto interface.
 */
export function instanceOfIBinSetupInfoDto(value: object): value is IBinSetupInfoDto {
    if (!('bin_setup' in value) || value['bin_setup'] === undefined) return false;
    return true;
}

export function IBinSetupInfoDtoFromJSON(json: any): IBinSetupInfoDto {
    return IBinSetupInfoDtoFromJSONTyped(json, false);
}

export function IBinSetupInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IBinSetupInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'bin_setup': json['bin_setup'],
        'bin_setup_state': json['bin_setup_state'] == null ? undefined : IFieldStateTypeFromJSON(json['bin_setup_state']),
    };
}

export function IBinSetupInfoDtoToJSON(json: any): IBinSetupInfoDto {
    return IBinSetupInfoDtoToJSONTyped(json, false);
}

export function IBinSetupInfoDtoToJSONTyped(value?: IBinSetupInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'bin_setup': value['bin_setup'],
        'bin_setup_state': IFieldStateTypeToJSON(value['bin_setup_state']),
    };
}

